"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseHoldersFromLCEvents = parseHoldersFromLCEvents;
exports.parseXTokensFromLCEvent = parseXTokensFromLCEvent;
const maps_js_1 = require("../../common/maps.js");
function parseHoldersFromLCEvents(events) {
    const holders = new Set();
    for (const event of events) {
        holders.add(event.sender);
    }
    return Array.from(holders);
}
// From descending order events
function parseXTokensFromLCEvent(events) {
    let userXTokens = [];
    const ownerPoolTokensMap = {};
    for (const event of events) {
        const sender = event.sender;
        const xTokens = event.user_total_x_token_balance;
        const pool = maps_js_1.poolIdPoolNameMap[event.pool_id];
        const key = `${sender}_${pool}`;
        if (!ownerPoolTokensMap[key]) {
            ownerPoolTokensMap[key] = xTokens;
        }
    }
    userXTokens = Object.entries(ownerPoolTokensMap).map(([owner_pool, xToken]) => {
        return [owner_pool.split("_")[0], owner_pool.split("_")[1], xToken];
    });
    return userXTokens;
}
//# sourceMappingURL=parseData.js.map